import { MultiSelectDesignTokens } from '@primeuix/themes/types/multiselect';

export const ezMultiselectThemeConfig: MultiSelectDesignTokens = {
  colorScheme: {
    light: {
      root: {
        focusBorderColor: '#167007',
        borderColor: 'var(--ez-border-color)',
        placeholderColor: 'var(--ez-text-hint-color)',
        hoverBorderColor: 'var(--ez-border-color)',
        color: 'var(--ez-primary-color)',
      },
      option: {
        selectedBackground: '#F3FFEB',
        focusBackground: '#F3FFEB',
        selectedFocusBackground: '#F3FFEB',
        selectedColor: '#167007',
      },
    },
  },
};
